function setFrame() {
  if (document.getElementById('oxg-app-frame')) return; // already framed

  const header = document.getElementById('brx-header');
  const content = document.getElementById('brx-content');
  const footer = document.getElementById('brx-footer');
  const appFrame = document.createElement('div');
  const appOffArea = document.createElement('div');
  const headerParent = header ? header.parentNode : document.querySelector('body');

  appFrame.id = 'oxg-app-frame';
  appFrame.classList.add('oxg-app-frame');

  appOffArea.id = 'oxg-app-off-area';
  appOffArea.classList.add('oxg-app-off-area');

  headerParent.insertBefore(appFrame, header);
  appFrame.parentNode.insertBefore(appOffArea, appFrame);

  if(header) { 
    appFrame.appendChild(header);
      header.classList.add('is-framed');
  } else {
    appFrame.classList.add('no-header');
  }
  if(content) {
    appFrame.appendChild(content);
    content.classList.add('is-framed'); 
  }
  if(footer) { 
    appFrame.appendChild(footer);
    footer.classList.add('is-framed'); 
  } else {
    appFrame.classList.add('no-footer');
  }
  appOffArea.appendChild(appFrame);

  document.dispatchEvent(new CustomEvent("appFrameSet"));
}

function removeFrame() {
  const appFrame = document.getElementById('oxg-app-frame');
  const appOffArea = document.getElementById('oxg-app-off-area');

  if (!appFrame || !appOffArea) return;

  const header = document.getElementById('brx-header');
  const content = document.getElementById('brx-content');
  const footer = document.getElementById('brx-footer');

  // move elements back out
  if (header) { appOffArea.parentNode.insertBefore(header, appOffArea) }
  appOffArea.parentNode.insertBefore(content, appOffArea);
  if (footer) { appOffArea.parentNode.insertBefore(footer, appOffArea) }

  if (header) { header.classList.remove('is-framed') }
  if (content) { content.classList.remove('is-framed') }
  if (footer) { footer.classList.remove('is-framed') }

  appOffArea.remove(); // removes wrapper and frame inside

  document.dispatchEvent(new CustomEvent("appFrameRemoved"));
}

function checkFrame() {
  if (oxgData.page_id == '2840' || oxgData.page_id == '2837') return;
  if (window.innerWidth >= 991 && !window.location.search.includes('bricks=run')) {
    setFrame();
  } else {
    removeFrame();
  }
}

document.addEventListener('DOMContentLoaded', checkFrame);
window.addEventListener('resize', checkFrame);
